// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"ade922fc","217":"ead11a8a","328":"5c031aeb","649":"87e12bd8","737":"87222bde","946":"6f3fb27a","999":"3595e7f3"}[chunkId] + ".chunk.js";
};